import script from "./ResetPasswordFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordFields.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__